import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { UtilService } from './util-service';
import { UtilServiceV2 } from './util-service-v2';
import { GestaoPcaService } from './gestao-pca-service';
import { saveAs } from 'file-saver';
import { AlertService } from './alert-service';
import { Observable, throwError } from 'rxjs';

/*
  Generated class for the AlertService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class FileService {

  constructor(private utilService: UtilService, 
    private UtilServiceV2: UtilServiceV2,
    private gestaoPcaService: GestaoPcaService,
    private alertService: AlertService) { }

  public cargaContrato(event) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('arquivoContratos', file, file.name);
      let envioRolXml: string = "contrato/carga?idPca=" + this.gestaoPcaService.getPCA().id;
      return this.utilService.postArquivo(envioRolXml, formData);
    }
  }

  public downloadModeloCargaContratoGestao(codTemplate) {
    var headers = new HttpHeaders();
    headers.append('responseType', 'arraybuffer');
    this.utilService.getJSON("contratosGestao/downloadTemplateCargaEmMassa?codTemplate=" + codTemplate)
      .subscribe(data => {
        let contentType = "data:" + data.mimeType + ";base64";

        let byteCharacters = atob(data.decodedFile);

        let byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);
        let file = new Blob([byteArray], { type: contentType });
        saveAs(file, data.filename);
      },
        error => console.log("Ocorreu um erro ao fazer o download do arquivo: " + error));
  }

  public downloadModeloCargaGestaoMateriais(codTemplate) {
    var headers = new HttpHeaders();
    headers.append('responseType', 'arraybuffer');
    this.utilService.getJSON("gestaoMateriais/downloadTemplates?codTemplate=" + codTemplate)
      .subscribe(data => {
        let contentType = "data:" + data.mimeType + ";base64";

        let byteCharacters = atob(data.decodedFile);

        let byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);
        let file = new Blob([byteArray], { type: contentType });
        saveAs(file, data.filename);
      },
        error => console.log("Ocorreu um erro ao fazer o download do arquivo: " + error));
  }

  public downloadModeloContrato() {
    var headers = new HttpHeaders();
    headers.append('responseType', 'arraybuffer');
    this.utilService.getJSON("contrato/downloadTemplateImportacao/")
      .subscribe(data => {
        let contentType = "data:" + data.mimeType + ";base64";

        let byteCharacters = atob(data.decodedFile);

        let byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);
        let file = new Blob([byteArray], { type: contentType });
        saveAs(file, data.filename);
      },
        error => console.log("Ocorreu um erro ao fazer o download do arquivo: " + error));
  }

  public downloadArquivoResumoRelatorioInspecao(idDoc) {
    var headers = new HttpHeaders();
    headers.append('responseType', 'arraybuffer');
    this.utilService.getJSON("analiseContrato/downloadDocumento/" + idDoc)
      .subscribe(data => {
        let contentType = "data:" + data.mimeType + ";base64";

        let byteCharacters = atob(data.decodedFile);

        let byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);
        let file = new Blob([byteArray], { type: contentType });
        saveAs(file, data.filename);
      },
        error => console.log("Ocorreu um erro ao fazer o download do arquivo: " + error));
  }

  public downloadArquivoRelatorioAuditoria(idPca) {
    var headers = new HttpHeaders();
    headers.append('responseType', 'arraybuffer');
    this.utilService.getJSON("analiseConvenios/downloadRelatorioAuditoria/" + idPca)
      .subscribe(data => {
        let contentType = "data:" + data.mimeType + ";base64";

        let byteCharacters = atob(data.decodedFile);

        let byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);
        let file = new Blob([byteArray], { type: contentType });
        saveAs(file, data.filename);
      },
        error => console.log("Ocorreu um erro ao fazer o download do arquivo: " + error));
  }


  public downloadModeloCargaPessoal(idTemplate) {
    var headers = new HttpHeaders();
    headers.append('responseType', 'arraybuffer');
    this.utilService.getJSON("arquivoPessoal/downloadTemplate/" + idTemplate)
      .subscribe(data => {

        console.log(data);
        let contentType = "data:" + data.mimeType + ";base64";

        let byteCharacters = atob(data.decodedFile);

        let byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);
        let file = new Blob([byteArray], { type: contentType });
        saveAs(file, data.filename);
      },
        error => console.log("Ocorreu um erro ao fazer o download do arquivo: " + error));
  }

  public cargaContratosGestao(event) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('arquivo', file, file.name);
      let envioRolXml: string = "contratosGestao/cargaContratos?idPca=" + this.gestaoPcaService.getPCA().id;
      return this.utilService.postArquivo(envioRolXml, formData);
    }
  }

  public cargaAnalises(event, idModuloAnalise) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('arquivo', file, file.name);
      let envioRolXml: string = "contratosGestao/cargaAnalises?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + idModuloAnalise;
      return this.utilService.postArquivo(envioRolXml, formData);
    }
  }

  public cargaInventarioMaterialConsumo(event, idModuloAnalise) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('arquivo', file, file.name);
      let envioRolXml: string = "gestaoMateriais/cargaInventarioMaterialConsumo?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + idModuloAnalise;
      return this.utilService.postArquivo(envioRolXml, formData);
    }
  }

  public cargaInventariosBens(event, idModuloAnalise,selecionarTodosChecked) {
    let fileList: FileList = event.target.files;
    let salvaXlsx = selecionarTodosChecked;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('arquivo', file, file.name);
      let envioRolXml: string = "gestaoMateriais/cargaInventariosBens?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + idModuloAnalise+ "&salvaXlsx=" + salvaXlsx;
      return this.utilService.postArquivo(envioRolXml, formData);
    }
  }

  public cargaAlienacoes(event, idModuloAnalise) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('arquivo', file, file.name);
      let envioRolXml: string = "gestaoMateriais/cargaAlienacoes?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + idModuloAnalise;
      return this.utilService.postArquivo(envioRolXml, formData);
    }
  }

  public cargaBaixaBensDoacao(event, idModuloAnalise) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('arquivo', file, file.name);
      let envioRolXml: string = "gestaoMateriais/cargaBaixaBensDoacao?idPca=" + this.gestaoPcaService.getPCA().id + "&cdAnalise=" + idModuloAnalise;
      return this.utilService.postArquivo(envioRolXml, formData);
    }
  }

  public cargaQuantitativoPessoalLotado(event, idModuloAnalise) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('xlsQuantitativo', file, file.name);
      let envioRolXml: string = "pessoal/importarQuantitativoPessoal/" + this.gestaoPcaService.getPCA().id + "?cdAnalise=" + idModuloAnalise;
      return this.utilService.postArquivo(envioRolXml, formData);
    }
  }

  public cargaQuadroNomeacaoCargos(event, idModuloAnalise) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('xlsQuadro', file, file.name);
      let envioRolXml: string = "pessoal/importarQuadroNomeacao/" + this.gestaoPcaService.getPCA().id + "?cdAnalise=" + idModuloAnalise;
      return this.utilService.postArquivo(envioRolXml, formData);
    }
  }

  public cargaRelacaoCargos(event) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('arquivo', file, file.name);
      let envioRolXml: string = "cargo/importarRelacaoCargos?idModulo=" + 11 + "&idPca=" + this.gestaoPcaService.getPCA().id;
      return this.utilService.postArquivo(envioRolXml, formData);
    }
  }

  public cargaRelacaoConvenios(event) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('arquivo', file, file.name);
      let envioRolXml: string = "convenios/importarRelacaoConveniosCelebrados?idPca=" + this.gestaoPcaService.getPCA().id;
      return this.utilService.postArquivo(envioRolXml, formData);
    }
  }

  public cargaRelacaoTomadaDeContasEspeciais(event) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('arquivo', file, file.name);
      let envioRolXml: string = "tomadaContaEspecial/carga?idPca=" + this.gestaoPcaService.getPCA().id;
      return this.utilService.postArquivo(envioRolXml, formData);
    }
  }

  public cargaRelacaoInadimplencias(event) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('arquivo', file, file.name);
      let envioRolXml: string = "convenios/importarComunicacaoInadimplencias?idPca=" + this.gestaoPcaService.getPCA().id;
      return this.utilService.postArquivo(envioRolXml, formData);
    }
  }

  public cargaQuadroPessoal(event, idModuloAnalise) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('xlsDemonstrativo', file, file.name);
      let envioRolXml: string = "pessoal/importarDemonstrativoQuadroPessoal/" + this.gestaoPcaService.getPCA().id + "?cdAnalise=" + idModuloAnalise;
      return this.utilService.postArquivo(envioRolXml, formData);
    }
  }

  public cargaContratosTerceirizacao(event, idModuloAnalise) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('xlsReferencia', file, file.name);
      let envioRolXml: string = "pessoal/importarReferenciaContratos/" + this.gestaoPcaService.getPCA().id + "?cdAnalise=" + idModuloAnalise;
      return this.utilService.postArquivo(envioRolXml, formData);
    }
  }

  // Salvar o arquivo na peça processual
  public salvarPeca(file: File, pIdProcesso, pcodigoModuloPCA, ptipoAnalise, pTipoEntidadeExercicio, pTipoDocumento, origemArquivo) {
      let formData: FormData = new FormData();
      console.log(file);
      formData.append('arquivo', file, file.name);
      console.log("idProcesso: " + pIdProcesso + " codigoModulo: " + pcodigoModuloPCA + " cdTipoAnalise: " + ptipoAnalise + " tipoEntidadeExercicio: " + pTipoEntidadeExercicio + " tipoDocumento: " + pTipoDocumento + " dsOrigemArquivo: " + origemArquivo);
      let envioPeca: string = "arquivo/salvar?id=" + pIdProcesso + "&codigoModulo=" + pcodigoModuloPCA + "&idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise=" + ptipoAnalise + "&tipoEntidadeExercicio=" + pTipoEntidadeExercicio + "&tipoDocumento=" + pTipoDocumento + "&dsOrigemArquivo=" + origemArquivo;
      return this.utilService.postArquivo(envioPeca, formData);
    //}
  }

  // Salvar o arquivo na peça processual
  public salvarPecaFile(file: File, pIdProcesso, pcodigoModuloPCA, ptipoAnalise, pTipoEntidadeExercicio, pTipoDocumento, origemArquivo) {
    // console.log("ENTROU NO SALVAR");
    // console.log(JSON.stringify(this.gestaoPcaService.getPCA()));

    let formData: FormData = new FormData();
    formData.append('arquivo', file, file.name);
    let envioPeca: string = "arquivo/salvar?id=" + pIdProcesso + "&codigoModulo=" + pcodigoModuloPCA + "&idPca=" + this.gestaoPcaService.getPCA().id + "&cdTipoAnalise=" + ptipoAnalise + "&tipoEntidadeExercicio=" + pTipoEntidadeExercicio + "&tipoDocumento=" + pTipoDocumento + "&dsOrigemArquivo=" + origemArquivo;
    return this.utilService.postArquivo(envioPeca, formData);
    // }
  }

  // Metodo exclusivo para Salvar Certificado no submeter PCA
  public salvarCertificadoPCA(file: File, pIdProcesso, pcodigoModuloPCA, ptipoAnalise, pTipoEntidadeExercicio, pTipoDocumento, origemArquivo) {
    let formData: FormData = new FormData();
    let nomeARquivo = "Teste";
    if(file.name){
      nomeARquivo = file.name;
    }
    formData.append('arquivo', file, nomeARquivo);
    let envioPeca: string = "arquivo/salvar?id=" + pIdProcesso + "&codigoModulo=" + pcodigoModuloPCA + "&idPca=" + pIdProcesso + "&cdTipoAnalise=" + ptipoAnalise + "&tipoEntidadeExercicio=" + pTipoEntidadeExercicio + "&tipoDocumento=" + pTipoDocumento + "&dsOrigemArquivo=" + origemArquivo;
    return this.utilService.postArquivo(envioPeca, formData);
  }

  // metodo para baixar arquivos vinculados no sistema
  public baixarArquivo(idArquivo) {
    var headers = new HttpHeaders();
    headers.append('responseType', 'arraybuffer');
    this.utilService.getJSON("arquivo/download/" + idArquivo)
      .subscribe(data => {
        if (data) {
          let contentType = "data:" + data.mimeType + ";base64";

          let byteCharacters = atob(data.decodedFile);

          let byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);
          let file = new Blob([byteArray], { type: contentType });
          saveAs(file, data.filename);
        } else {
          this.alertService.mostraAlerta("Arquivo não localizado.", "Tente novamente");
        }
      },
        error => {
          console.log("Ocorreu um erro ao fazer o download do arquivo: " + error);
          this.alertService.mostraAlerta("", "Ocorreu um erro ao fazer o download do arquivo: " + error.mensagem);
        });
  }

  // Remove o arquivo do sistema.
  public deletarArquivo(idArquivo) {
    let urlObtencaoDados = "arquivo/deletar/" + idArquivo;
    return this.utilService.deleteJSON(urlObtencaoDados);
  }

  public enviarArquivo(event, id, cdModulo, cdArquivo) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('arquivo', file, file.name);
      let envioRolXml: string = "arquivo/salvar?id=" + id + "&codigoModulo=" + cdModulo + "&idPca=" + this.gestaoPcaService.getPCA().id + "&codigoArquivo=" + cdArquivo;
      return this.utilService.postArquivo(envioRolXml, formData);
    }
  }

  public downloadArquivo(idArquivoContrato) {
    var headers = new HttpHeaders();
    headers.append('responseType', 'arraybuffer');
    console.log(idArquivoContrato);
    this.utilService.getJSON("arquivo/download/" + idArquivoContrato)
      .subscribe(data => {
        let contentType = "data:" + data.mimeType + ";base64";

        let byteCharacters = atob(data.decodedFile);

        let byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);
        let file = new Blob([byteArray], { type: contentType });
        saveAs(file, data.filename);
      },
        error => console.log("Ocorreu um erro ao fazer o download do arquivo: " + error));
  }

  public obterPorId(id) {
    let urlObtencaoDados = "arquivo/obterPorId/" + id;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public listarArquivo(id, cdModulo, codigoArquivo) {
    let urlObtencaoDados = "arquivo/listarArquivosVinculados/" + this.gestaoPcaService.getPCA().id + "/" + id + "/" + cdModulo + "/" + codigoArquivo+ "/" + false;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public cargaProdutos(event) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('arquivo', file, file.name);
      let envioRolXml: string = "produto/cargaProdutos?idPca=" + this.gestaoPcaService.getPCA().id;
      return this.utilService.postArquivo(envioRolXml, formData);
    }
  }

  public downloadModeloCargaProduto() {
    var headers = new HttpHeaders();
    headers.append('responseType', 'arraybuffer');
    this.utilService.getJSON("produto/downloadTemplateCargaEmMassa")
      .subscribe(data => {

        console.log(data);
        let contentType = "data:" + data.mimeType + ";base64";

        let byteCharacters = atob(data.decodedFile);

        let byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);
        let file = new Blob([byteArray], { type: contentType });
        saveAs(file, data.filename);
      },
        error => console.log("Ocorreu um erro ao fazer o download do arquivo: " + error));
  }

  public downloadRelatorioInstrucao(idPca: number): Observable<any> {
    return this.UtilServiceV2.getJSON("relatorioInstrucao/odt/" + idPca);
  }

}



// WEBPACK FOOTER //
// ./src/providers/file-service.ts